import Box from '@mui/material/Box';
import { useTheme } from '@doxyme/ui-foundation/theme';

import type { JSX } from 'react';

type Props = {
  icon: JSX.Element;
};

export const NotificationIcon = ({ icon }: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        justifyContent: 'flex-start',
        color: theme.icon.primary,
      }}
    >
      {icon}
    </Box>
  );
};
